import axios from "axios";
import * as env from "./core/env";

export const serverUrl = `https://${env["SUBDOMAIN"]}.companyapp.net`;
export const subdomain = env["SUBDOMAIN"];
export const fileSystemUrl = env["FS"];
export const ssoEnabled = env["SSO_ENABLED"];
export const dataPath = `https://addinconfig.companyapp.net`;

export const api = axios.create({
  baseURL: serverUrl,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});
